import React, { useState } from "react";
import { Link } from "react-router-dom";
import { FormGroup, FormControl, ControlLabel } from "react-bootstrap";
import "./Signup.css";
import LoaderButton from "../components/LoaderButton";
import axios from 'axios';

const MIN_PASSWORD_LENGTH = 8;

export default function Signup(props) {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [isLoading, setIsLoading] = useState(false);

    const passwordsMatch = confirmPassword.length > 0 && confirmPassword === password;
    const passwordLongEnough = password.length >= MIN_PASSWORD_LENGTH;
    const emailValid = email.trim().length > 0;
    const canSubmit = emailValid && passwordLongEnough && passwordsMatch;

    function getValidationHint() {
        if(email.trim().length > 0 && password.length === 0 && confirmPassword.length === 0) {
            return `Use at least ${MIN_PASSWORD_LENGTH} characters for your password.`;
        }
        if(password.length > 0 && !passwordLongEnough) {
            return `Password must be at least ${MIN_PASSWORD_LENGTH} characters.`;
        }
        if(confirmPassword.length > 0 && !passwordsMatch) {
            return "Passwords do not match.";
        }
        if(passwordLongEnough && passwordsMatch && !emailValid) {
            return "Please enter an email address for your account.";
        }
        return `Create an account with your email and a password of at least ${MIN_PASSWORD_LENGTH} characters.`;
    }

    async function handleSignup(event) {
        event.preventDefault();
        if(!canSubmit) return;

        setIsLoading(true);
        const fixedEmail = email.trim().toLowerCase();

        try {
            await axios.post(
                `${process.env.REACT_APP_API_URL}/users`,
                {"email": fixedEmail, "password": password},
                {headers: {'Content-Type': 'application/json', 'accept': 'application/json'}}
            );
            props.setErrorStatus("success-message");
            props.setErrorMessage("Account created. Please log in.");
            props.setShowError(true);
            props.history.push('/login');
        } catch(error) {
            if(error.response && error.response.status === 500) {
                props.setErrorMessage("User already exists. Please try logging in.");
                props.history.push('/login');
            } else {
                props.setErrorMessage("Unknown error. Please try again later.");
            }
            props.setErrorStatus("error-message");
            props.setShowError(true);
            console.log(error);
            setIsLoading(false);
        }
    }

    const hintIsError = (confirmPassword.length > 0 && !passwordsMatch)
        || (password.length > 0 && !passwordLongEnough)
        || (passwordLongEnough && passwordsMatch && email.length > 0 && !emailValid);

    return (
        <div className="signup-page">
            <header className="signup-header">
                <h1>Create Account</h1>
                <p className="signup-subtitle">
                    Sign up to access your Bedrock Wireless cameras.
                </p>
            </header>

            <div className="signup-panel">
                <form className="signup-form" onSubmit={handleSignup}>
                    <FormGroup controlId="email">
                        <ControlLabel>Email</ControlLabel>
                        <FormControl
                            autoFocus
                            type="email"
                            autoComplete="email"
                            value={email}
                            onChange={e => setEmail(e.target.value)}
                        />
                    </FormGroup>
                    <FormGroup controlId="password">
                        <ControlLabel>Password</ControlLabel>
                        <FormControl
                            type="password"
                            autoComplete="new-password"
                            value={password}
                            onChange={e => setPassword(e.target.value)}
                        />
                    </FormGroup>
                    <FormGroup controlId="confirmPassword">
                        <ControlLabel>Confirm Password</ControlLabel>
                        <FormControl
                            type="password"
                            autoComplete="new-password"
                            value={confirmPassword}
                            onChange={e => setConfirmPassword(e.target.value)}
                        />
                    </FormGroup>
                    <p className={`signup-hint ${hintIsError ? "signup-hint--error" : ""}`}>
                        {getValidationHint()}
                    </p>
                    <div className="signup-actions">
                        <LoaderButton
                            block
                            type="submit"
                            className="btn-brand-dark"
                            bsSize="large"
                            isLoading={isLoading}
                            disabled={!canSubmit}
                        >
                            Sign Up
                        </LoaderButton>
                        <p className="signup-footer">
                            Already have an account? <Link to="/login">Log in</Link>
                        </p>
                    </div>
                </form>
            </div>
        </div>
    );
}
